import type { Component, MasterPageDefinition } from '@wix/thunderbolt-becky-types'
import { envRefs } from '@wix/thunderbolt-catharsis'
import { createCssCompNode } from '../cssCompNode'
import type { FeatureRefs } from '../cssFeatures.types'

export const accessibilityStyle = createCssCompNode('accessibility', 'accessibilityStyle', {
	getDependencies: (component: Component, refs: FeatureRefs<'accessibility'>) => {
		const masterPageData =
			component.type === 'Document' ? refs.dataQuery<MasterPageDefinition['data']>(component.dataQuery!) : null

		return {
			masterPageData,
			experiments: envRefs.experiments,
		}
	},
	toViewItem: (__, deps): { isVisualFocusDisabled: boolean; isExperimentChangeFocusRing: boolean } => {
		const masterPageData = deps.masterPageData as MasterPageDefinition['data']

		// Checking if the master page has accessibility settings and if the visual focus is disabled
		// Sometimes we don't have accessibilitySettings on Mobile and then we need to consider that in our logic
		const isVisualFocusSettingsDisabled =
			(masterPageData as any)?.accessibilitySettings?.visualFocusDisabled === true

		return {
			// For all components except the master page or if visual focus is disabled, we don't want to generate any accessibility styles
			isVisualFocusDisabled: !masterPageData || isVisualFocusSettingsDisabled,
			isExperimentChangeFocusRing: !!deps.experiments['specs.thunderbolt.changeFocusRing'],
		}
	},
})
